import validate from "/var/www/html/bp-web-menu-v2-dev/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/html/bp-web-menu-v2-dev/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "get-root-data": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/getRootData.ts"),
  "get-shop-categories": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/getShopCategories.ts"),
  "get-structured-data": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/getStructuredData.ts"),
  "get-valid-order": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/getValidOrder.ts"),
  "has-cart-items": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/hasCartItems.ts"),
  "is-logged-in": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/isLoggedIn.ts"),
  "set-color-mode": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/setColorMode.ts"),
  "validate-password-request": () => import("/var/www/html/bp-web-menu-v2-dev/middleware/validatePasswordRequest.ts")
}